/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { OauthServiceService } from './services/oauth-service.service';
import { AccountsServiceService } from './services/accounts-service.service';
import { SshkeysServiceService } from './services/sshkeys-service.service';
import { NameserverServiceService } from './services/nameserver-service.service';
import { DropletsServiceService } from './services/droplets-service.service';
import { ImagesServiceService } from './services/images-service.service';
import { RegionsServiceService } from './services/regions-service.service';
import { SizesServiceService } from './services/sizes-service.service';
import { VolumesServiceService } from './services/volumes-service.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    OauthServiceService,
    AccountsServiceService,
    SshkeysServiceService,
    NameserverServiceService,
    DropletsServiceService,
    ImagesServiceService,
    RegionsServiceService,
    SizesServiceService,
    VolumesServiceService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
